<template>
  <section v-if="completeLoadingTarget">
    <div v-if="isExistingOrder && !targetReady" class="text-center py-4">
      <LoadingSpinner />
    </div>
    <template v-else>
    <div class="row ">
      <div class="col-12 d-flex align-items-center justify-content-end">
        <div class="mr-3 d-flex align-items-center" v-if="this.$store.state.authentication.user.role_id == 1">
          <span class="mr-2 small">v1</span>
          <label class="switch mb-0">
            <input 
              type="checkbox" 
              v-model="version" 
              @change="changeVersion()"
              :true-value="2" 
              :false-value="1"
              :disabled="isDisabled || selectDisable || disabledForm"
            >
            <span class="slider"></span>
          </label>
          <span class="ml-2 small">v2</span>
        </div>
        <button
          class="btn btn-primary mb-2 text-center"
          :disabled="filterButtonDisabled"
          @click="changeSomething()"
        >
          Filter
        </button>
        <span
          v-if="disabledForm"
          class="ml-3 d-inline-flex align-items-center border border-primary rounded px-2 py-1 text-danger bg-light"
        >
          <i class="fas fa-exclamation-triangle mr-2 text-danger"></i>
          {{ $t("lang.label.filter_change_not_allowed") }}
        </span>
      </div>
    </div>

    <div class="row" v-if="contactSearchErrorMessage">
      <div class="col-12">
        <div
          class="alert alert-warning d-flex align-items-start mb-3"
          role="alert"
        >
          <i class="fas fa-exclamation-triangle mr-2 mt-1"></i>
          <div>
            <strong>{{ $t("lang.label.contact_search_error_title") }}</strong>
            <div class="small mb-0">{{ contactSearchErrorMessage }}</div>
          </div>
        </div>
      </div>
    </div>

    <div class="row" v-if="version === 2 && appliedFiltersReport">
      <div class="col-12">
        <div
          class="alert d-flex align-items-start mb-3"
          :class="appliedFiltersReport.ignored.length ? 'alert-warning' : 'alert-success'"
          role="status"
        >
          <i
            class="fas mr-2 mt-1"
            :class="appliedFiltersReport.ignored.length ? 'fa-exclamation-triangle' : 'fa-check-circle'"
          ></i>
          <div class="w-100">
            <strong v-if="appliedFiltersReport.ignored.length">
              {{ $t("lang.search.filter_applied_summary_title") }}
            </strong>
            <div
              class="small mb-0"
              :class="appliedFiltersReport.ignored.length ? 'mt-1' : ''"
            >
              {{ appliedFiltersSummaryText }}
            </div>
            <p
              v-if="appliedFiltersReport.ignored.length"
              class="small text-muted mb-2 mt-2"
            >
              {{ $t("lang.search.filter_ignored_help") }}
            </p>
            <p
              v-if="appliedFiltersReport.ignored.length"
              class="small text-muted mb-2"
            >
              {{ $t("lang.search.filter_why_selectable") }}
            </p>
            <ul
              v-if="appliedFiltersReport.ignored.length"
              class="small mb-0 pl-3"
            >
              <li
                v-for="(item, idx) in appliedFiltersReport.ignored"
                :key="'ignored-filter-' + idx"
                class="mb-2"
              >
                <span class="badge badge-warning text-dark mr-1">
                  {{ $t("lang.search.filter_ignored_short") }}
                </span>
                <span class="text-muted mr-1">({{ formatAppliedFilterType(item) }})</span>
                <strong>{{ formatAppliedFilterLabel(item) }}</strong>
                <div class="text-muted mt-1">
                  {{ filterReasonLabel(item) }}
                </div>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>

    <div class="row" v-if="shouldShowSalesridgeLaunchAlert">
      <div class="col-12">
        <div
          class="alert d-flex align-items-start mb-3"
          :class="salesridgeLaunchAlertClass"
          role="alert"
        >
          <i :class="salesridgeLaunchAlertIconClass" class="mr-2 mt-1"></i>
          <div class="w-100">
            <strong>{{ salesridgeLaunchAlertTitle }}</strong>
            <p class="small mb-2 mt-1">
              {{ salesridgeLaunchAlertBody }}
            </p>
            <button
              type="button"
              class="btn btn-sm btn-warning"
              :disabled="relaunchingSalesridge"
              @click="relaunchSalesridgeSearch"
            >
              <span
                v-if="relaunchingSalesridge"
                class="spinner-border spinner-border-sm mr-1"
              />
              {{ $t("lang.search.filter_relaunch_salesridge_button") }}
            </button>
            <p
              v-if="relaunchSalesridgeMessage"
              class="small mb-0 mt-2"
              :class="relaunchSalesridgeMessageClass"
            >
              {{ relaunchSalesridgeMessage }}
            </p>
            <p class="small text-muted mb-0 mt-1">
              {{ $t("lang.search.filter_relaunch_salesridge_hint") }}
            </p>
          </div>
        </div>
      </div>
    </div>

    <!-- ROLE DU CONTACT -->
    <div id="accordion">
      <div class="card">
        <div class="card-header p-0 d-flex align-items-center" id="headingTwo">
          <div class="col-9 p-0">
            <h5 class="mb-0">
              <button
                class="btn btn-link text-dark collapsed"
                data-toggle="collapse"
                data-target="#collapseThree"
                aria-expanded="false"
                aria-controls="collapseThree"
              >
                {{ $t("lang.category_job_group.contact_role") }}
              </button>
            </h5>
          </div>

          <div class="col-3 text-right" v-if="hasRoleFilters">
            <span
              class="text-primary"
              :class="{ 'cursor-pointer': !(isDisabled || selectDisable) }"
              :data-toggle="!(isDisabled || selectDisable) ? 'collapse' : ''"
              data-target="#collapseThree"
              aria-expanded="false"
              aria-controls="collapseThree"
            >
              <i v-if="!(isDisabled || selectDisable)" class="icon-pencil"></i>
              <Tooltip
                v-else
                :text="$t('lang.label.target_no_editable')"
                :width="''"
              >
                <i class="icon-pencil text-gray"></i>
              </Tooltip>
            </span>
            <span
              v-if="onBoarding.target_status_id != '4'"
              class="text-primary mx-2"
              :class="{ 'cursor-pointer': !(isDisabled || selectDisable) }"
              @click="
                !(isDisabled || selectDisable) ? deleteFilter('role') : ''
              "
            >
              <i v-if="!(isDisabled || selectDisable)" class="icon-close"></i>
              <Tooltip
                v-else
                :text="$t('lang.label.target_no_editable')"
                :width="''"
              >
                <i class="icon-close text-gray"></i>
              </Tooltip>
            </span>
          </div>
        </div>
        <div
          id="collapseThree"
          class="collapse show"
          aria-labelledby="headingTwo"
          data-parent="#accordion"
        >
          <div class="card-body">
            <Tabs
              :tabSelected="tabSelected"
              :tabs="tabs"
              @change="changeTab($event)"
            />

            <div class="mt-3" v-show="tabSelected == 1">
              <span
                v-if="loadingCategory"
                class="loadingres mr-2 ml-2 spinner-border loading-spinner"
              ></span>
              <select
                v-if="!loadingCategory"
                v-model="categoryKey"
                class="d-inline form-control"
                :disabled="isDisabled || selectDisable || disabledForm"
                @change="setCategories()"
              >
                <option
                  v-for="item in categories_jobs_group.filter(
                    e => e.category != 'Custom_Job_Titles'
                  )"
                  :key="item.category"
                  :value="item.category"
                  class="optionSelect"
                  :class="{
                    'text-primary': item.category === 'Custom_Job_Titles',
                    'font-weight-bold': item.category === 'Custom_Job_Titles'
                  }"
                >
                  {{ $t("lang.category_job_group." + item.category) }}
                </option>
              </select>

              <i 
              v-if="hasPermissions('superAdmin') && this.$route.fullPath.includes('/orders/')"
              class="icon icon-clipboard cursor-pointer mr-2 ml-2"
              :title="$t('lang.general.copytoclipboard')"
              @click="copyContent(categoryKey)"></i>

              <div class="mt-3">
              
                <KeyWordSearch
                  :taglimit="version === 2 ? includedTagLimit : 99"
                  :taglimitNotAnyOf="version === 2 ? excludedTagLimit : null"
                  :multipleValuesAtOnce="true"
                  :showSubcategoryClear="true"
                  :isDisabled="
                    isDisabled ||
                      selectDisable ||
                      onBoarding.target_status_id == 4
                  "
                  ref="jobtitlePredefined"
                  :default_values="onBoarding.target.categories_jobs"
                  @change="changeKeywords($event)"
                  v-if="!loadingCategory"
                  :anyOf="valueAnyOf"
                />
              </div>
            </div>
            <div class="mt-3" v-show="tabSelected == 2">
              <span
                v-if="loadingCategory"
                class="loadingres mr-2 ml-2 spinner-border loading-spinner"
              ></span>


              <KeyWordSearch
                :taglimit="version === 2 ? includedTagLimit : 99"
                :taglimitNotAnyOf="version === 2 ? excludedTagLimit : null"
                :multipleValuesAtOnce="true"
                :showSubcategoryClear="true"
                :isDisabled="isDisabled || selectDisable || disabledForm"
                ref="jobtitleCustom"
                :default_values="onBoarding.target.categories_jobs"
                @change="changeKeywords($event)"
                v-if="!loadingCategory"
                :anyOf="valueAnyOf"
              />
              <div class="p-2 mr-3 d-flex align-items-center" v-if="this.$store.state.authentication.user.role_id == 1">
                <div v-if="version ==2">

                  <small class="text-primary mr-2">Exact match: (v2)</small> 
                  <small class="icon icon-close text-danger p-2"></small>
                  <label class="switch mb-0">
                    <input 
                      type="checkbox" 
                      v-model="exactmatch" 
                      @change="changeExactMatch()"
                      :true-value="2" 
                      :false-value="1"
                      :disabled="isDisabled || selectDisable || disabledForm"
                    >
                    <span class="slider"></span>
                  </label>
                  <small class="icon icon-checkmark text-success p-2"></small>
                </div>
              </div>

            </div>

            <div class="mt-3 mb-3 text-danger float-right" v-if="version === 2">
              <b>Included:</b> {{ includedJobsCount }} / {{ includedTagLimit }}
              <span v-if="includedTagAvailable < 0"
                ><b> ( you must deselect {{ Math.abs(includedTagAvailable) }} item(s) )</b></span
              >
              &middot;
              <b>Excluded:</b> {{ excludedJobsCount }} / {{ excludedTagLimit }}
              <span v-if="excludedTagAvailable > 0"
                ><b> ( available {{ excludedTagAvailable }} ) </b></span
              >
              <span v-else-if="excludedTagAvailable === 0"
                ><b>
                  ( Exclusion limit reached ({{ excludedTagLimit }} max). Remove exclusions to add new ones. )</b
                ></span
              >
              <span v-else
                ><b>
                  ( you must deselect {{ Math.abs(excludedTagAvailable) }} exclusion(s) )</b
                ></span
              >
            </div>
            <div class="mt-3 mb-3 text-danger float-right" v-else>
              <b>Max 99 items</b> between the two inputs
              <span v-if="shareTagLimit >= 0"
                ><b> ( available {{ shareTagLimit }} ) </b></span
              >
              <span v-else
                ><b>
                  ( you must deselect {{ Math.abs(shareTagLimit) }} item(s) )</b
                ></span
              >
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- INDUSTRIE -->
    <div id="accordion">
      <div class="card mt-2">
        <div class="card-header p-0 d-flex align-items-center" id="headingTwo">
          <div class="col-9 p-0">
            <h5 class="mb-0">
              <button
                class="btn btn-link text-dark collapsed"
                data-toggle="collapse"
                data-target="#industry"
                aria-expanded="false"
                aria-controls="industry"
              >
                {{ $t("lang.category_job_group.industry") }}
              </button>
            </h5>
          </div>

          <div
            class="col-3 text-right"
            v-if="
              onBoarding.target.sectors_include.length > 0 ||
                onBoarding.target.sectors_exclude.length > 0
            "
          >
            <span
              class="text-primary"
              :class="{ 'cursor-pointer': !(isDisabled || selectDisable) }"
              :data-toggle="!(isDisabled || selectDisable) ? 'collapse' : ''"
              data-target="#industry"
              aria-expanded="false"
              aria-controls="industry"
            >
              <i v-if="!(isDisabled || selectDisable)" class="icon-pencil"></i>
              <Tooltip
                v-else
                :text="$t('lang.label.target_no_editable')"
                :width="''"
              >
                <i class="icon-pencil text-gray"></i>
              </Tooltip>
            </span>
            <span
              v-if="onBoarding.target_status_id != '4'"
              class="text-primary mx-2"
              :class="{ 'cursor-pointer': !(isDisabled || selectDisable) }"
              @click="
                !(isDisabled || selectDisable) ? deleteFilter('industry') : ''
              "
            >
              <i v-if="!(isDisabled || selectDisable)" class="icon-close"></i>
              <Tooltip
                v-else
                :text="$t('lang.label.target_no_editable')"
                :width="''"
              >
                <i class="icon-close text-gray"></i>
              </Tooltip>
            </span>
          </div>
        </div>
        <div
          id="industry"
          class="collapse"
          aria-labelledby="industry"
          data-parent="#accordion"
        >
          <!-- version 1: endpoint viejo, multiselect plano -->
          <div class="card-body" v-if="version !== 2">
            <span
              v-if="loadingCategory"
              class="loadingres mr-2 ml-2 spinner-border loading-spinner"
            ></span>
            <div
              v-if="!loadingCategory"
              class="d-flex align-items-center justify-content-between mt-2"
            >
              <p class="mb-0">{{ $t("lang.onBoarding.include") }}</p>
              <span
                v-if="
                  onBoarding.target.sectors_include.length > 0 &&
                    canClearSubcategory()
                "
                class="text-primary cursor-pointer"
                @click="clearIndustrySubcategory('include')"
              >
                <i class="icon-close"></i>
              </span>
            </div>
            <IndustrySearch
              v-if="!loadingCategory"
              :key="'industry-include-v1-' + version"
              :option_list="filteredCategoriesGoogle"
              :default_values="onBoarding.target.sectors_include"
              :isDisabled="isDisabled || selectDisable || version === 2 || disabledForm"
              :fromOrder="true"
              :showSeeMoreButton="true"
              :flattenSearchResults="true"
              @input="updateSectorsInclude"
            >
            </IndustrySearch>
            <div
              v-if="!loadingCategory"
              class="d-flex align-items-center justify-content-between mt-2"
            >
              <p class="mb-0">{{ $t("lang.onBoarding.exclude") }}</p>
              <span
                v-if="
                  onBoarding.target.sectors_exclude.length > 0 &&
                    canClearSubcategory()
                "
                class="text-primary cursor-pointer"
                @click="clearIndustrySubcategory('exclude')"
              >
                <i class="icon-close"></i>
              </span>
            </div>
            <IndustrySearch
              v-if="!loadingCategory"
              :key="'industry-exclude-v1-' + version"
              :option_list="filteredCategoriesGoogle"
              :default_values="onBoarding.target.sectors_exclude"
              :isDisabled="isDisabled || selectDisable || version === 2 || disabledForm"
              :fromOrder="true"
              :openDirection="'top'"
              :showSeeMoreButton="true"
              :flattenSearchResults="true"
              @input="updateSectorsExclude"
            >
            </IndustrySearch>
          </div>

          <!-- version con jerarquia -->
          <!-- <div class="card-body">
            <span
              v-if="loadingCategory"
              class="loadingres mr-2 ml-2 spinner-border loading-spinner"
            ></span>
            <p v-if="!loadingCategory" class="mt-2">
              {{ $t("lang.onBoarding.include") }}
            </p>
            <IndustrySearch
              v-if="!loadingCategory"
              :option_list="filteredCategoriesGoogle"
              :default_values="onBoarding.target.sectors_include"
              :isDisabled="isDisabled || selectDisable || version === 2 || disabledForm"
              :fromOrder="true"
              :flattenSearchResults="false"
              :showSeeMoreButton="true"
              @input="onSectorsIncludeInputHierarchy"
            >
            </IndustrySearch>
            <p v-if="!loadingCategory" class="mt-2">
              {{ $t("lang.onBoarding.exclude") }}
            </p>
            <IndustrySearch
              v-if="!loadingCategory"
              :option_list="filteredCategoriesGoogle"
              :default_values="onBoarding.target.sectors_exclude"
              :isDisabled="isDisabled || selectDisable || version === 2 || disabledForm"
              :fromOrder="true"
              :flattenSearchResults="false"
              :showSeeMoreButton="true"
              @input="onSectorsExcludeInputHierarchy"
            >
            </IndustrySearch>
          </div> -->
          
          <!-- version 2: endpoint nuevo con jerarquía (padre > hijo > nieto) -->
          <div class="card-body" v-if="version === 2">
            <small class="text-primary" v-if="version == 2">V2</small>
            <span
              v-if="loadingCategory"
              class="loadingres mr-2 ml-2 spinner-border loading-spinner"
            ></span>
            <div
              v-if="!loadingCategory"
              class="d-flex align-items-center justify-content-between mt-2"
            >
              <p class="mb-0">{{ $t("lang.onBoarding.include") }}</p>
              <span
                v-if="
                  onBoarding.target.sectors_include.length > 0 &&
                    canClearSubcategory()
                "
                class="text-primary cursor-pointer"
                @click="clearIndustrySubcategory('include')"
              >
                <i class="icon-close"></i>
              </span>
            </div>
            <IndustrySearch
              v-if="!loadingCategory"
              :key="'industry-include-v2-' + version"
              :option_list="filteredCategoriesGoogleV2"
              :default_values="onBoarding.target.sectors_include"
              :isDisabled="isDisabled || selectDisable || disabledForm"
              :fromOrder="true"
              :flattenSearchResults="false"
              :showSeeMoreButton="true"
              :allowTypeAndSelect="true"
              @input="onSectorsIncludeInputHierarchy"
            >
            </IndustrySearch>
            <div
              v-if="!loadingCategory"
              class="d-flex align-items-center justify-content-between mt-2"
            >
              <p class="mb-0">{{ $t("lang.onBoarding.exclude") }}</p>
              <span
                v-if="
                  onBoarding.target.sectors_exclude.length > 0 &&
                    canClearSubcategory()
                "
                class="text-primary cursor-pointer"
                @click="clearIndustrySubcategory('exclude')"
              >
                <i class="icon-close"></i>
              </span>
            </div>
            <IndustrySearch
              v-if="!loadingCategory"
              :key="'industry-exclude-v2-' + version"
              :option_list="filteredCategoriesGoogleV2"
              :default_values="onBoarding.target.sectors_exclude"
              :isDisabled="isDisabled || selectDisable || disabledForm"
              :fromOrder="true"
              :flattenSearchResults="false"
              :openDirection="'top'"
              :showSeeMoreButton="true"
              :allowTypeAndSelect="true"
              @input="onSectorsExcludeInputHierarchy"
            >
            </IndustrySearch>
          </div>
          
        </div>
      </div>
    </div>

    <!-- EFFECTIF DE L´ENTREPRISE -->
    <div id="accordion">
      <div class="card mt-2">
        <div class="card-header p-0 d-flex align-items-center" id="headingTwo">
          <div class="col-9 p-0">
            <h5 class="mb-0">
              <button
                class="btn btn-link text-dark collapsed"
                data-toggle="collapse"
                data-target="#headcount"
                aria-expanded="false"
                aria-controls="headcount"
              >
                {{ $t("lang.category_job_group.companyHeadCount") }}
              </button>
            </h5>
          </div>

          <div
            class="col-3 text-right"
            v-if="onBoarding.target.sizes.length > 0"
          >
            <span
              class="text-primary"
              :class="{ 'cursor-pointer': !(isDisabled || selectDisable) }"
              :data-toggle="!(isDisabled || selectDisable) ? 'collapse' : ''"
              data-target="#headcount"
              aria-expanded="false"
              aria-controls="headcount"
            >
              <i v-if="!(isDisabled || selectDisable)" class="icon-pencil"></i>
              <Tooltip
                v-else
                :text="$t('lang.label.target_no_editable')"
                :width="''"
              >
                <i class="icon-pencil text-gray"></i>
              </Tooltip>
            </span>
            <span
              v-if="onBoarding.target_status_id != '4'"
              class="text-primary mx-2"
              :class="{ 'cursor-pointer': !(isDisabled || selectDisable) }"
              @click="
                !(isDisabled || selectDisable) ? deleteFilter('headcount') : ''
              "
            >
              <i v-if="!(isDisabled || selectDisable)" class="icon-close"></i>
              <Tooltip
                v-else
                :text="$t('lang.label.target_no_editable')"
                :width="''"
              >
                <i class="icon-close text-gray"></i>
              </Tooltip>
            </span>
          </div>
        </div>
        <div
          id="headcount"
          class="collapse"
          aria-labelledby="headcount"
          data-parent="#accordion"
        >
          <div class="card-body">
            <span
              v-if="loadingCategory"
              class="loadingres mr-2 ml-2 spinner-border loading-spinner"
            ></span>
            <IndustrySearch
              v-if="!loadingCategory"
              :option_list="select_list_sizes"
              :default_values="onBoarding.target.sizes"
              :isDisabled="isDisabled || selectDisable || disabledForm"
              :fromOrder="true"
              @input="updateSizes"
            >
            </IndustrySearch>
          </div>
        </div>
      </div>
    </div>

    <!-- LOCALISATION DU CONTACT -->
    <div id="accordion">
      <div class="card mt-2">
        <div class="card-header p-0 d-flex align-items-center" id="headingTwo">
          <div class="col-9 p-0">
            <h5 class="mb-0">
              <button
                class="btn btn-link text-dark collapsed"
                data-toggle="collapse"
                data-target="#geography"
                aria-expanded="false"
                aria-controls="geography"
              >
                {{ $t("lang.category_job_group.geography") }}
              </button>
            </h5>
          </div>

          <div
            class="col-3 text-right"
            v-if="hasGeographyFilters"
          >
            <span
              class="text-primary"
              :class="{ 'cursor-pointer': !(isDisabled || selectDisable) }"
              :data-toggle="!(isDisabled || selectDisable) ? 'collapse' : ''"
              data-target="#geography"
              aria-expanded="false"
              aria-controls="geography"
            >
              <i v-if="!(isDisabled || selectDisable)" class="icon-pencil"></i>
              <Tooltip
                v-else
                :text="$t('lang.label.target_no_editable')"
                :width="''"
              >
                <i class="icon-pencil text-gray"></i>
              </Tooltip>
            </span>
            <span
              class="text-primary mx-2"
              :class="{ 'cursor-pointer': !(isDisabled || selectDisable) }"
              @click="
                !(isDisabled || selectDisable) ? deleteFilter('geography') : ''
              "
            >
              <i v-if="!(isDisabled || selectDisable)" class="icon-close"></i>
              <Tooltip
                v-else
                :text="$t('lang.label.target_no_editable')"
                :width="''"
              >
                <i class="icon-close text-gray"></i>
              </Tooltip>
            </span>
          </div>
        </div>
        <div
          id="geography"
          class="collapse"
          aria-labelledby="geography"
          data-parent="#accordion"
        >
          <div class="card-body">
            <span
              v-if="loadingCategory"
              class="loadingres mr-2 ml-2 spinner-border loading-spinner"
            ></span>

          <span class="ml-2 small">v1</span>
            <IndustrySearch
              v-if="!loadingCategory"
              class="mb-4"
              :option_list="this.$store.state.optionsList.all['countries'].data"
              :default_values="onBoarding.target.contact_country"
              :isDisabled="isDisabled || selectDisable || disabledForm || version == 2"
              :openDirection="'top'"
              :fromOrder="true"
              @input="updateCountries"
            >
            </IndustrySearch> 

            <small class="text-primary" v-if="version == 2">V2</small>
            <p
              v-if="version == 2 && filterValidationLoading"
              class="small text-muted mb-2 mt-1"
            >
              {{ $t("lang.search.filter_validation_loading") }}
            </p>
            <p
              v-if="version == 2 && filterPreviewTotal !== null && !filterValidationLoading"
              class="small text-muted mb-2 mt-1"
            >
              {{ $t("lang.search.filter_validation_preview") }}:
              {{ filterPreviewTotal.toLocaleString() }}
              <span class="ml-2">
                <span class="badge badge-success">{{ $t("lang.search.filter_applied_short") }}</span>
                <span class="badge badge-warning text-dark ml-1">{{ $t("lang.search.filter_ignored_short") }}</span>
              </span>
            </p>
            <KeyWordSearch
              :isDisabled="isDisabled || selectDisable || disabledForm"
              :multipleValuesAtOnce="true"
              :showSubcategoryClear="true"
              v-if="!loadingCategory && version == 2"
              @change="onKeywordFilterChange($event)"
              ref="location_keywords"
              :notAnyOf="false"
              :default_values="onBoarding.target.location_keywords"
              :tag-status="filterTagStatus"
            />

          </div>
        </div>
      </div>
    </div>

    <!-- LIEU DU SIEGE DE L´ENTREPRISE -->
    <div id="accordion">
      <div class="card mt-2">
        <div class="card-header p-0 d-flex align-items-center" id="headingTwo">
          <div class="col-9 p-0">
            <h5 class="mb-0">
              <button
                class="btn btn-link text-dark collapsed"
                data-toggle="collapse"
                data-target="#location"
                aria-expanded="false"
                aria-controls="location"
              >
                {{ $t("lang.category_job_group.companyHeadQuarterLocation") }}
              </button>
            </h5>
          </div>

          <div
            class="col-3 text-right"
            v-if="hasLocationFilters"
          >
            <span
              class="text-primary"
              :class="{ 'cursor-pointer': !(isDisabled || selectDisable) }"
              :data-toggle="!(isDisabled || selectDisable) ? 'collapse' : ''"
              data-target="#location"
              aria-expanded="false"
              aria-controls="location"
            >
              <i v-if="!(isDisabled || selectDisable)" class="icon-pencil"></i>
              <Tooltip
                v-else
                :text="$t('lang.label.target_no_editable')"
                :width="''"
              >
                <i class="icon-pencil text-gray"></i>
              </Tooltip>
            </span>
            <span
              class="text-primary mx-2"
              :class="{ 'cursor-pointer': !(isDisabled || selectDisable) }"
              @click="
                !(isDisabled || selectDisable) ? deleteFilter('location') : ''
              "
            >
              <i v-if="!(isDisabled || selectDisable)" class="icon-close"></i>
              <Tooltip
                v-else
                :text="$t('lang.label.target_no_editable')"
                :width="''"
              >
                <i class="icon-close text-gray"></i>
              </Tooltip>
            </span>
          </div>
        </div>
        <div
          id="location"
          class="collapse"
          aria-labelledby="location"
          data-parent="#accordion"
        >
          <div class="card-body">
            <!-- <h6 class="mt-4">{{ $t("lang.onBoarding.step2_4_question") }}</h6> -->
            <span
              v-if="loadingCategory"
              class="loadingres mr-2 ml-2 spinner-border loading-spinner"
            ></span>
            <!-- INDUSTRY ANTIGUO DONDE SE AGREGABAN LAS REGIONS PRECARGADAS-->
            <IndustrySearch
              v-if="
                !loadingCategory &&
                  onBoarding.target.company_location.length > 0
              "
              :option_list="this.$store.state.optionsList.all['regions'].data"
              :default_values="onBoarding.target.company_location"
              :isDisabled="
                isDisabled || selectDisable || selectedOptions.length > 0 || disabledForm
              "
              :fromOrder="true"
              @input="updateRegions"
            >
            </IndustrySearch>
            <!-- FIN INDUSTRY ANTIGUO DONDE SE AGREGABAN LAS REGIONS PRECARGADAS-->
            <div class="select-container mt-3">
              <input
                type="text"
                v-model="searchQuery"
                @input="getLocationsApollo"
                @keypress.enter="addOption(searchQuery)"
                v-bind:placeholder="
                  $t('lang.onBoarding.step2_company_location')
                "
                :disabled="disabledForm"
                class="form-control"
              />
              <ul
                class="options-list list-group"
                v-if="searchQuery != ''"
                style="max-height: 200px; overflow-y: auto"
              >
                <li
                  v-if="locations.length == 0 && this.searchQuery != ''"
                  class="list-group-item"
                  :class="option === hoverOption ? 'active' : ''"
                  @mouseover="hoverOption = option"
                >
                  location not found, please press enter to add
                </li>
                <li
                  v-for="option in locations"
                  :key="option.id"
                  @click="addOption(option)"
                  class="list-group-item"
                  :class="option === hoverOption ? 'active' : ''"
                  @mouseover="hoverOption = option"
                >
                  {{ option.cleaned_name }}
                </li>
              </ul>
            </div>

            <!-- INDUSTRY DONDE SE AGREGAN la busqueda de locaciones-->
            <IndustrySearch
              class="mt-3"
              v-if="!loadingCategory"
              :option_list="placesOptions"
              :default_values="selectedOptions"
              :isDisabled="placesOptions.length == 0 ? true : false || disabledForm"
              :fromOrder="true"
              @deleted="removeOption($event)"
            >
            </IndustrySearch>
            <!-- FIN INDUSTRY DONDE SE AGREGAN la busqueda de locaciones -->
          </div>
        </div>
      </div>
    </div>

    <!-- MOTS CLÉS -->
    <div id="accordion">
      <div class="card mt-2">
        <div class="card-header p-0 d-flex align-items-center" id="headingFive">
          <div class="col-9 p-0">
            <h5 class="mb-0">
              <button
                class="btn btn-link text-dark collapsed"
                data-toggle="collapse"
                data-target="#industry_keywords"
                aria-expanded="false"
                aria-controls="industry_keywords"
              >
                {{ $t("lang.search.keywords") }}
              </button>
            </h5>
          </div>

          <div
            class="col-3 text-right"
            v-if="
              (onBoarding.target.industry_keywords.anyof !== undefined &&
                onBoarding.target.industry_keywords.anyof.length > 0) ||
                (onBoarding.target.industry_keywords.notanyof !== undefined &&
                  onBoarding.target.industry_keywords.notanyof.length > 0)
            "
          >
            <span
              class="text-primary"
              :class="{ 'cursor-pointer': !(isDisabled || selectDisable) }"
              :data-toggle="!(isDisabled || selectDisable) ? 'collapse' : ''"
              data-target="#industry_keywords"
              aria-expanded="false"
              aria-controls="industry_keywords"
            >
              <i v-if="!(isDisabled || selectDisable)" class="icon-pencil"></i>
              <Tooltip
                v-else
                :text="$t('lang.label.target_no_editable')"
                :width="''"
              >
                <i class="icon-pencil text-gray"></i>
              </Tooltip>
            </span>
            <span
              class="text-primary mx-2"
              :class="{ 'cursor-pointer': !(isDisabled || selectDisable) }"
              @click="
                !(isDisabled || selectDisable)
                  ? deleteFilter('industry_keywords')
                  : ''
              "
            >
              <i v-if="!(isDisabled || selectDisable)" class="icon-close"></i>
              <Tooltip
                v-else
                :text="$t('lang.label.target_no_editable')"
                :width="''"
              >
                <i class="icon-close text-gray"></i>
              </Tooltip>
            </span>
          </div>
        </div>

        <div
          id="industry_keywords"
          class="collapse"
          aria-labelledby="industry_keywords"
          data-parent="#accordion"
        >
          <div class="card-body">
            <span
              v-if="loadingCategory"
              class="loadingres mr-2 ml-2 spinner-border loading-spinner"
            ></span>

            <KeyWordSearch
              :isDisabled="isDisabled || selectDisable || disabledForm "
              :multipleValuesAtOnce="true"
              :showSubcategoryClear="true"
              v-if="!loadingCategory"
              @change="onKeywordFilterChange($event)"
              ref="industry_keywords"
              :default_values="onBoarding.target.industry_keywords"
              :tag-status="filterTagStatus"
            />
          </div>
        </div>
      </div>
    </div>

    <!-- SPECIALTIES -->
    <div id="accordion" v-if="version == 2">
      <div class="card mt-2">
        <div class="card-header p-0 d-flex align-items-center" id="headingSix">
          <div class="col-9 p-0">
            <h5 class="mb-0">
              <button
                class="btn btn-link text-dark collapsed"
                data-toggle="collapse"
                data-target="#specialties"
                aria-expanded="false"
                aria-controls="specialties"
              >
                {{ $t("lang.search.specialties") }}
              </button>
            </h5>
          </div>

          <div
            class="col-3 text-right"
            v-if="
              (onBoarding.target.specialties !== undefined &&
              onBoarding.target.specialties.anyof !== undefined &&
                onBoarding.target.specialties.anyof.length > 0) ||
                (onBoarding.target.specialties !== undefined &&
                onBoarding.target.specialties.notanyof !== undefined &&
                  onBoarding.target.specialties.notanyof.length > 0)
            "
          >
            <span
              class="text-primary"
              :class="{ 'cursor-pointer': !(isDisabled || selectDisable) }"
              :data-toggle="!(isDisabled || selectDisable) ? 'collapse' : ''"
              data-target="#specialties"
              aria-expanded="false"
              aria-controls="specialties"
            >
              <i v-if="!(isDisabled || selectDisable)" class="icon-pencil"></i>
              <Tooltip
                v-else
                :text="$t('lang.label.target_no_editable')"
                :width="''"
              >
                <i class="icon-pencil text-gray"></i>
              </Tooltip>
            </span>
            <span
              class="text-primary mx-2"
              :class="{ 'cursor-pointer': !(isDisabled || selectDisable) }"
              @click="
                !(isDisabled || selectDisable)
                  ? deleteFilter('specialties')
                  : ''
              "
            >
              <i v-if="!(isDisabled || selectDisable)" class="icon-close"></i>
              <Tooltip
                v-else
                :text="$t('lang.label.target_no_editable')"
                :width="''"
              >
                <i class="icon-close text-gray"></i>
              </Tooltip>
            </span>
          </div>
        </div>

        <div
          id="specialties"
          class="collapse"
          aria-labelledby="specialties"
          data-parent="#accordion"
        >
          <div class="card-body">
            <span
              v-if="loadingCategory"
              class="loadingres mr-2 ml-2 spinner-border loading-spinner"
            ></span>

            <KeyWordSearch
              :isDisabled="isDisabled || selectDisable || disabledForm "
              :multipleValuesAtOnce="true"
              :showSubcategoryClear="true"
              v-if="!loadingCategory"
              @change="onKeywordFilterChange($event)"
              ref="specialties"
              :default_values="onBoarding.target.specialties"
              :tag-status="filterTagStatus"
            />
          </div>
        </div>
      </div>
    </div>

    <div class="mt-2" v-if="this.$store.state.authentication.user.role_id == 1">
      <div class="form-group">
        <label for="summary" class="font-weight-bold">Summary</label>
        <textarea
          v-model="onBoarding.target.summary"
          id="w3review"
          name="w3review"
          rows="4"
          cols="50"
          class="form-control"
          style="resize:none"
          :disabled="disabledForm "
        />
      </div>
    </div>
    </template>
  </section>
</template>

<script>
import IndustrySearch from "@/components/AccountCreation/Steps/Campaign/search/IndustrySearch.vue";
import LoadingSpinner from "@/components/LoadingSpinner.vue";
import { targetsService } from "@/_services";
import Tabs from "@/components/Common/Tabs.vue";
import Fieldset from "@/components/Common/Fieldset.vue";
import { mapState, mapActions } from "vuex";
import KeyWordSearch from "@/components/AccountCreation/Steps/Campaign/search/KeyWordSearch.vue";
import Tooltip from "@/components/Common/Tooltip.vue";
import axios from "axios";
import industryHierarchyMixin from "@/_mixins/industryHierarchyMixin";
import { formatContactSearchError } from "@/_helpers/salesridgeSearchError";
import {
  formatSalesridgeRelaunchError,
  shouldShowSalesridgeLaunchButton,
  shouldShowSalesridgeMismatchBanner,
} from "@/_helpers/salesridgeLaunchUi";

export default {
  mixins: [industryHierarchyMixin],
  props: {
    selectDisable: {
      type: Boolean,
      required: false,
      default: () => true
    },
    poupView: {
      type: Boolean,
      required: false,
      default: () => false
    }
  },

  data() {
    return {
      exactmatch: false,
      disabledForm: false,
      shareTagLimit: 99,
      // Limites job titles V2 (independientes). V1 usa shareTagLimit (99 compartido)
      includedTagLimit: 5000,
      excludedTagLimit: 800,
      includedTagAvailable: 5000,
      excludedTagAvailable: 800,
      tabSelected: 1,
      size: {
        greater: 0,
        less: 0
      },
      tabs: {
        1: {
          id: 1,
          name: this.$t("lang.orders.predefined_audience"),
          disabled: this.isDisabled || this.selectDisable
        },
        2: {
          id: 2,
          name: this.$t("lang.orders.title_job_custom"),
          disabled: this.isDisabled || this.selectDisable
        }
      },
      keywordscant: 0,
      addSelect: false,
      categoryKey: "General_Management_Owners",
      loadingCategory: false,
      locations: [],
      hoverOption: null,
      searchQuery: [],
      apollo: {
        total_result: 0,
        people: []
      },
      valueAnyOf: false,
      valNotAnyOf: true,
      fieldsetHtml: "",
      hoverOption: null,
      filteredOptions: [],
      selectedOptions: [],
      placesOptions: [],
      data: {
        categories_industry: [],
        categories_not_industry: [],
        employees: {
          keywords: {
            greater: 0,
            less: 0
          }
        },
        categories_level: [],
        categories_function: [],
        categories_jobs: {},
        specialties:{},
        location_keywords:{},
        industry_keywords: {},
        region: [],
        countries: []
      },
      select_list_sizes: [
        { id: 0, label: "1-10" },
        { id: 1, label: "11-20" },
        { id: 2, label: "21-50" },
        { id: 3, label: "51-100" },
        { id: 4, label: "101-200" },
        { id: 5, label: "201-500" },
        { id: 6, label: "501-1000" },
        { id: 7, label: "1001-2000" },
        { id: 8, label: "2001-5000" },
        { id: 9, label: "5001-10000" },
        { id: 10, label: "10001+" }
      ],
      selected_sizes: [],
      version: 1,
      filterTagStatus: {},
      filterValidationLoading: false,
      filterValidationTimer: null,
      filterPreviewTotal: null,
      _targetInitDone: false,
      _pendingFilterMismatchCheck: false,
      filterTotalMismatchVisible: false,
      relaunchingSalesridge: false,
      relaunchSalesridgeMessage: "",
      relaunchSalesridgeMessageClass: "text-muted"
    };
  },

  components: {
    IndustrySearch,
    KeyWordSearch,
    Fieldset,
    Tabs,
    Tooltip,
    LoadingSpinner
  },
  computed: {
    includedJobsCount() {
      const cj = this.onBoarding.target && this.onBoarding.target.categories_jobs;
      return cj && Array.isArray(cj.anyof) ? cj.anyof.length : 0;
    },
    excludedJobsCount() {
      const cj = this.onBoarding.target && this.onBoarding.target.categories_jobs;
      return cj && Array.isArray(cj.notanyof) ? cj.notanyof.length : 0;
    },
    ...mapState({
      completeLoadingTarget: state => state.optionsList.completeLoadingTarget,
      onBoarding: state => state.onboarding,
      isDisabled: state => state.onboarding.isDisable,
      categories_jobs_group: state =>
        state.optionsList.all["category_jobs_group"].data
    }),

    // version sin jerarquia
    // filteredCategoriesGoogle() {
    //   const categoriesGoogleAll = this.$store.state.optionsList.all.categories_google_all;
    //   const allCategories = (categoriesGoogleAll && categoriesGoogleAll.data) || [];
    //   return allCategories.filter(item => item.version === '1');
    // },
    // filteredCategoriesGoogleV2() {
    //   const categoriesGoogleAll = this.$store.state.optionsList.all.categories_google_all;
    //   const allCategories = (categoriesGoogleAll && categoriesGoogleAll.data) || [];
    //   return allCategories.filter(item => item.version === '2');
    // },
    
    // Jerarquía padre > hijo > nieto (sin filtrar por version en raíz; los leaves tienen version)
    filteredCategoriesGoogle() {
      const categoriesGoogleAll = this.$store.state.optionsList.all.categories_google_all;
      return (categoriesGoogleAll && categoriesGoogleAll.data) || [];
    },
    filteredCategoriesGoogleV2() {
      const hierarchy = this.$store.state.optionsList.all.categories_google_hierarchy;
      return (hierarchy && hierarchy.data) || [];
    },
    hasRoleFilters() {
      const cj = this.onBoarding.target.categories_jobs;
      return (
        this.categoryKey !== "" ||
        (cj && cj.anyof && cj.anyof.length > 0) ||
        (cj && cj.notanyof && cj.notanyof.length > 0)
      );
    },
    hasGeographyFilters() {
      const lk = this.onBoarding.target.location_keywords;
      return (
        (this.onBoarding.target.contact_country &&
          this.onBoarding.target.contact_country.length > 0) ||
        (lk && lk.anyof && lk.anyof.length > 0) ||
        (lk && lk.notanyof && lk.notanyof.length > 0)
      );
    },
    hasLocationFilters() {
      const t = this.onBoarding.target;
      return (
        this.placesOptions.length > 0 ||
        (t.company_location && t.company_location.length > 0) ||
        (t.places && t.places.length > 0)
      );
    },
    contactSearchErrorMessage() {
      return formatContactSearchError(
        this.$i18n,
        this.onBoarding.apollo.search_error
      );
    },
    appliedFiltersReport() {
      if (this.version !== 2 || this.onBoarding.isDisable) {
        return null;
      }

      const filters = this.onBoarding.apollo.applied_filters || [];
      if (!filters.length) {
        return null;
      }

      return {
        applied: filters.filter(item => item.status === "applied"),
        ignored: filters.filter(item => item.status === "ignored"),
      };
    },
    appliedFiltersSummaryText() {
      if (!this.appliedFiltersReport) {
        return "";
      }

      const total =
        this.onBoarding.apollo.total_result === null ||
        this.onBoarding.apollo.total_result === undefined
          ? "—"
          : Number(this.onBoarding.apollo.total_result).toLocaleString();

      return this.$t("lang.search.filter_applied_summary_intro", {
        applied: this.appliedFiltersReport.applied.length,
        ignored: this.appliedFiltersReport.ignored.length,
        total,
      });
    },
    isExistingOrder() {
      return (
        Number(this.onBoarding.orderId) > 0 &&
        this.onBoarding.typeForm !== "add"
      );
    },
    targetReady() {
      if (!this.isExistingOrder) {
        return true;
      }
      return !this.onBoarding.loading;
    },
    filterButtonDisabled() {
      return this.isDisabled || (this.isExistingOrder && this.onBoarding.loading);
    },
    isAdmin() {
      return Number(this.$store.state.authentication.user.role_id) === 1;
    },
    salesridgeLaunchUi() {
      return this.onBoarding.apollo.salesridge_launch_ui || null;
    },
    filterTotalMismatchPercent() {
      const ui = this.salesridgeLaunchUi;
      if (ui && ui.diff_pct !== null && ui.diff_pct !== undefined) {
        return Math.abs(Math.round(Number(ui.diff_pct)));
      }
      return 0;
    },
    salesridgeLaunchSavedTotal() {
      const ui = this.salesridgeLaunchUi;
      return ui
        ? Number(ui.saved_total_contacts) || 0
        : Number(this.onBoarding.total_contacts) || 0;
    },
    salesridgeLaunchPreviewTotal() {
      const ui = this.salesridgeLaunchUi;
      return ui
        ? Number(ui.preview_total_contacts) || 0
        : Number(this.onBoarding.apollo.total_result) || 0;
    },
    shouldShowSalesridgeLaunchAlert() {
      return (
        this.isAdmin &&
        this.isExistingOrder &&
        this.filterTotalMismatchVisible &&
        shouldShowSalesridgeLaunchButton(this.salesridgeLaunchUi) &&
        !this.onBoarding.isDisable &&
        !this.onBoarding.apollo.search_error
      );
    },
    shouldShowFilterTotalMismatch() {
      return (
        this.shouldShowSalesridgeLaunchAlert &&
        shouldShowSalesridgeMismatchBanner(this.salesridgeLaunchUi)
      );
    },
    salesridgeLaunchAlertClass() {
      return this.shouldShowFilterTotalMismatch
        ? "alert-warning"
        : "alert-info";
    },
    salesridgeLaunchAlertIconClass() {
      return this.shouldShowFilterTotalMismatch
        ? "fas fa-exclamation-triangle"
        : "fas fa-info-circle";
    },
    salesridgeLaunchAlertTitle() {
      if (this.shouldShowFilterTotalMismatch) {
        return this.$t("lang.search.filter_total_mismatch_title");
      }
      return this.$t("lang.search.filter_salesridge_launch_pending_title");
    },
    salesridgeLaunchAlertBody() {
      const saved = this.salesridgeLaunchSavedTotal;
      const preview = this.salesridgeLaunchPreviewTotal;
      if (this.shouldShowFilterTotalMismatch) {
        return this.$t("lang.search.filter_total_mismatch_body", {
          saved: saved.toLocaleString(),
          preview: preview.toLocaleString(),
          percent: this.filterTotalMismatchPercent,
        });
      }
      return this.$t("lang.search.filter_salesridge_launch_pending_body", {
        preview: preview.toLocaleString(),
        saved: saved.toLocaleString(),
      });
    },
  },
  watch: {
    "onBoarding.isDisable"(isDisabled, wasDisabled) {
      if (wasDisabled && !isDisabled && this._pendingFilterMismatchCheck) {
        this._pendingFilterMismatchCheck = false;
        this.filterTotalMismatchVisible = shouldShowSalesridgeLaunchButton(
          this.onBoarding.apollo.salesridge_launch_ui
        );
        if (!this.filterTotalMismatchVisible) {
          this.relaunchSalesridgeMessage = "";
        }
      }
    },
    "onBoarding.orderId"() {
      this._targetInitDone = false;
    },
    "onBoarding.loading"(loading) {
      if (!loading && this.isExistingOrder) {
        this.initializeFromLoadedTarget();
      }
    },
    "onBoarding.targetWasLoaded"(loaded) {
      if (loaded && this.isExistingOrder) {
        this.initializeFromLoadedTarget();
      }
    },
    "onBoarding.apollo.applied_filters": {
      handler(filters) {
        if (this.version !== 2 || !Array.isArray(filters) || !filters.length) {
          return;
        }

        this.syncFilterTagStatusFromApollo(filters);

        if (
          this.onBoarding.apollo.total_result !== null &&
          this.onBoarding.apollo.total_result !== undefined
        ) {
          this.filterPreviewTotal = this.onBoarding.apollo.total_result;
        }
      },
      deep: true,
    },
  },
  created() {

    if(this.onBoarding.target_status_id == '4'){
      if(!this.onBoarding.apollo.total_result || (this.onBoarding.apollo.total_result && this.onBoarding.apollo.total_result <= 10000)){
        if(this.onBoarding.total_contacts != 0){
          this.disabledForm = true;
        }
      }

      if (this.onBoarding.total_contacts > 10000) {
      	    this.disabledForm = false;
      }

      
      if (this.onBoarding.apollo.total_result && this.onBoarding.apollo.total_result > 10000) {
	    this.disabledForm = false;
      }

    }

    if (this.$store.state.onboarding.version == 2) {
      this.version = 2;
    }

    if(this.$store.state.onboarding.target.categories_jobs.exactmatch == 2){
      this.exactmatch = 2;
    }

    if 
    (
    this.onBoarding &&
    this.onBoarding.target &&
    this.onBoarding.target.categories_jobs &&
    this.onBoarding.target.categories_jobs.anyof &&
    this.onBoarding.target.categories_jobs.anyof.length > 0
    ) {
        this.onBoarding.target.categories_jobs.anyof.forEach(item => {
          if (item.word && item.word.includes("&amp;")) {
            item.word = item.word.replace(/&amp;/g, "&");
          }
        });
    }
    
    this.selected_sizes = this.onBoarding.target.sizes;
    this.addSelect = true;

    if (this.poupView) {
      //this.getApollo();
    }
  },
  mounted() {
    if (this.isExistingOrder) {
      if (this.targetReady) {
        this.initializeFromLoadedTarget();
      }
      return;
    }

    this.syncCategoryKeyFromStore();

    if (this.categoryKey != "Custom_Job_Titles") {
      this.setCategories();
    } else {
      this.calcShareTagLimit();
    }

    this.syncPlacesFromStore();

    if (this.version === 2) {
      this.scheduleFilterValidation();
    }
  },

  beforeDestroy() {
    if (this.filterValidationTimer) {
      clearTimeout(this.filterValidationTimer);
    }
  },

  methods: {
    ...mapActions("onboarding", {
      getApollo: "getApollo",
      calculateSize: "calculateSize",
      updateCategorySelect: "updateCategorySelect",
      updateSectorsInclude: "updateSectorsInclude",
      updateSectorsExclude: "updateSectorsExclude",
      updateSizes: "updateSizes",
      updateCountries: "updateCountry",
      updateRegions: "updateRegion"
    }),
    /** Solo para Industry con jerarquía (padre/hijo/nieto): expande a ids de nietos antes de guardar. */
    onSectorsIncludeInputHierarchy(ids) {
      const tree = this.version === 2 ? this.filteredCategoriesGoogleV2 : this.filteredCategoriesGoogle
      const leafIds = this.getLeafIdsFromIndustrySelection(ids || [], tree || [])
      this.updateSectorsInclude(leafIds)
    },
    /** Solo para Industry con jerarquía: expande a ids de nietos antes de guardar. */
    onSectorsExcludeInputHierarchy(ids) {
      const tree = this.version === 2 ? this.filteredCategoriesGoogleV2 : this.filteredCategoriesGoogle
      const leafIds = this.getLeafIdsFromIndustrySelection(ids || [], tree || [])
      this.updateSectorsExclude(leafIds)
    },
    changeExactMatch(){
      this.onBoarding.target.categories_jobs.exactmatch = this.exactmatch
    },
    copyContent(type){

      let textToCopy = this.categories_jobs_group.filter(
          e => e.category == type
        )

      try {
        // Copiar al portapapeles (moderno)
        navigator.clipboard.writeText(textToCopy[0].words)
        .then(() => {
          console.log("Etiquetas copiadas al portapapeles ✅");
        })
        .catch(() => {
          // fallback para navegadores viejos
          const textarea = document.createElement("textarea");
          textarea.value = textToCopy;
          document.body.appendChild(textarea);
          textarea.select();
          document.execCommand("copy");
          document.body.removeChild(textarea);
          console.log("Etiquetas copiadas al portapapeles ✅ (fallback)");
        });
      } catch (error) {
        console.error("Error al copiar etiquetas:", error);
      }
    },
     changeVersion(){
       // Actualizar la versión en el store de onboarding
       // Usar $set para asegurar reactividad si la propiedad no existe
       this.$set(this.onBoarding, 'version', this.version);
       this.calcShareTagLimit();
     },
    hasPermissions(perm) {
      return this.$store.getters["authentication/hasPermissions"](perm);
    },
    calcShareTagLimit() {
      this.shareTagLimit = 99;
      this.shareTagLimit = 99 - this.includedJobsCount - this.excludedJobsCount;
      this.includedTagAvailable = this.includedTagLimit - this.includedJobsCount;
      this.excludedTagAvailable = this.excludedTagLimit - this.excludedJobsCount;
    },
    changeTab(id) {
      this.tabSelected = id;
      if (id === 2) {
        // Tab de Custom_Job_Titles - no borrar valores existentes
        this.categoryKey = "Custom_Job_Titles";
        this.valueAnyOf = true;
        this.updateCategorySelect(this.categoryKey);
        this.calcShareTagLimit();
      } else {
        // Tab de categorías predefinidas
        this.valueAnyOf = false;
        // Solo establecer categoría por defecto si no hay una seleccionada
        // y si no hay valores existentes en categories_jobs
        const hasExistingValues = this.onBoarding.target.categories_jobs && 
          this.onBoarding.target.categories_jobs.anyof && 
          this.onBoarding.target.categories_jobs.anyof.length > 0;
        
        if ((!this.categoryKey || this.categoryKey === "Custom_Job_Titles") && !hasExistingValues) {
          // Solo cargar categoría por defecto si no hay valores existentes
          this.categoryKey = "General_Management_Owners";
          this.setCategories();
        } else if (!this.categoryKey || this.categoryKey === "Custom_Job_Titles") {
          // Si hay valores pero no hay categoría, establecer una sin borrar valores
          this.categoryKey = "General_Management_Owners";
          this.updateCategorySelect(this.categoryKey);
          this.calcShareTagLimit();
        } else {
          // Si ya hay una categoría seleccionada, solo actualizar
          this.updateCategorySelect(this.categoryKey);
          this.calcShareTagLimit();
        }
      }
    },

    setCategories() {
      this.loadingCategory = true;
      this.valueAnyOf = false;
      let targetJobs = this.onBoarding.target.categories_jobs;
      this.updateCategorySelect(this.categoryKey);
      
      // Solo limpiar y rellenar si no estamos en el tab de Custom_Job_Titles
      if (this.categoryKey != "Custom_Job_Titles") {
        targetJobs.anyof = [];
        this.categories_jobs_group.map(element => {
          if (element.category == this.categoryKey) {
            let values = element.words.split(",");
            values.forEach(element => {
              targetJobs.anyof.push({ word: element.trim() });
            });
          }
        });
      }
      // Si es Custom_Job_Titles, no hacer nada para preservar los valores existentes
      
      this.changeKeywords(targetJobs);
      this.calcShareTagLimit();
    },
    onKeywordFilterChange(e) {
      this.changeSpecialties(e);
      this.scheduleFilterValidation();
    },
    buildFilterValidationPayload() {
      const t = this.onBoarding.target;
      const employees = this.onBoarding.size || {};

      return {
        categories_industry: t.sectors_include || [],
        categories_not_industry: t.sectors_exclude || [],
        countries: t.contact_country || [],
        places: t.places || [],
        location_keywords: t.location_keywords || { anyof: [], notanyof: [] },
        industry_keywords: t.industry_keywords || { anyof: [], notanyof: [] },
        specialties: t.specialties || { anyof: [], notanyof: [] },
        categories_jobs: t.categories_jobs || {},
        employees
      };
    },
    scheduleFilterValidation() {
      if (this.version !== 2) {
        return;
      }
      if (this.filterValidationTimer) {
        clearTimeout(this.filterValidationTimer);
      }
      this.filterValidationTimer = setTimeout(() => {
        this.runFilterValidation();
      }, 1500);
    },
    formatAppliedFilterLabel(item) {
      return item.value || item.mapped_label || String(item.id || "");
    },
    formatAppliedFilterType(item) {
      if (!item || !item.type) {
        return "";
      }

      const key = `lang.search.filter_type_${item.type}`;
      const translated = this.$t(key);
      return translated === key ? item.type : translated;
    },
    filterReasonLabel(item) {
      if (!item || !item.reason) {
        return "";
      }

      const key = `lang.search.filter_reason_${item.reason}`;
      const params = {
        value: item.value || "",
        mapped: item.mapped_label || item.source_label || "",
      };
      const translated = this.$t(key, params);
      return translated === key ? item.reason : translated;
    },
    syncFilterTagStatusFromApollo(filters) {
      const tagStatus = { ...this.filterTagStatus };

      filters.forEach(item => {
        if (
          item.value &&
          [
            "location_keyword",
            "industry_keyword",
            "specialty",
            "job_title",
          ].includes(item.type)
        ) {
          tagStatus[item.value] = item.status;
        }
      });

      this.filterTagStatus = tagStatus;
    },
    runFilterValidation() {
      if (this.version !== 2) {
        return;
      }

      this.calculateSize();

      const payload = {
        data: this.buildFilterValidationPayload(),
        version: 2
      };
      if (this.onBoarding.orderId) {
        payload.target_id = this.onBoarding.orderId;
      }

      this.filterValidationLoading = true;
      targetsService
        .validateSalesridgeFilters(payload)
        .then(res => {
          if (!res || !res.supported) {
            return;
          }
          this.filterPreviewTotal =
            res.preview_total === null || res.preview_total === undefined
              ? null
              : res.preview_total;
          const tagStatus = { ...this.filterTagStatus };
          (res.filters || []).forEach(item => {
            if (item.value) {
              tagStatus[item.value] = item.status;
            }
          });
          this.filterTagStatus = tagStatus;
        })
        .catch(() => {
          this.filterTagStatus = {};
        })
        .finally(() => {
          this.filterValidationLoading = false;
        });
    },
    changeSpecialties(e) {
      setTimeout(() => {

        this.loadingCategory = false;
      }, 1000);
      this.calcShareTagLimit();
    },
    changeKeywords(e) {
      //  this.changeSomething();

      setTimeout(() => {
        if (this.categoryKey == "Custom_Job_Titles") {
          this.valueAnyOf = true;
        }

        this.loadingCategory = false;
      }, 1000);
      this.calcShareTagLimit();
      this.scheduleFilterValidation();
    },

    resetKeywordFilter(target, field) {
      target[field] = { anyof: [], notanyof: [] };
    },

    canClearSubcategory() {
      return (
        !this.isDisabled &&
        !this.selectDisable &&
        !this.disabledForm &&
        this.onBoarding.target_status_id != "4"
      );
    },

    clearIndustrySubcategory(type) {
      if (!this.canClearSubcategory()) return;

      this.loadingCategory = true;
      if (type === "include") {
        this.onBoarding.target.sectors_include = [];
        this.updateSectorsInclude([]);
      } else {
        this.onBoarding.target.sectors_exclude = [];
        this.updateSectorsExclude([]);
      }
      this.changeKeywords();
    },

    deleteFilter(filter) {
      this.loadingCategory = true;

      let targetJobs = this.onBoarding.target;

      if (filter == "location") {
        targetJobs.company_location = [];
        targetJobs.places = [];
        this.placesOptions = [];
        this.selectedOptions = [];
        this.searchQuery = "";
        this.locations = [];
      }

      if (filter == "industry") {
        targetJobs.sectors_include = [];
        targetJobs.sectors_exclude = [];
      }

      if (filter == "industry_keywords") {
        this.resetKeywordFilter(targetJobs, "industry_keywords");
      }
      if (filter == "specialties") {
        this.resetKeywordFilter(targetJobs, "specialties");
      }
      if (filter == "location_keywords") {
        this.resetKeywordFilter(targetJobs, "location_keywords");
      }

      if (filter == "geography") {
        targetJobs.contact_country = [];
        this.resetKeywordFilter(targetJobs, "location_keywords");
      }

      if (filter == "headcount") {
        targetJobs.sizes = [];
      }

      if (filter == "role") {
        if (targetJobs.categories_jobs) {
          targetJobs.categories_jobs.anyof = [];
          targetJobs.categories_jobs.notanyof = [];
          targetJobs.categories_jobs.exactmatch = 1;
        }
        this.exactmatch = 1;
        this.categoryKey = "";
        this.tabSelected = 1;
        this.valueAnyOf = false;
        this.updateCategorySelect(this.categoryKey);
      }

      this.changeKeywords(targetJobs);
    },

    syncCategoryKeyFromStore() {
      this.categories_jobs_group.map(element => {
        if (this.onBoarding.target.category_select == element.category) {
          this.categoryKey = element.category;

          if (this.categoryKey == "Custom_Job_Titles") {
            this.valueAnyOf = true;
            this.tabSelected = 2;
          }
        }
      });
    },
    syncPlacesFromStore() {
      this.placesOptions = [];
      this.selectedOptions = [];

      if (
        this.onBoarding.target.places &&
        this.onBoarding.target.places.length > 0
      ) {
        this.onBoarding.target.places.forEach(item => {
          let element = {
            id: item,
            label: item
          };
          this.placesOptions.push(element);
          this.selectedOptions.push(item);
        });
      }
    },
    initializeFromLoadedTarget() {
      if (this._targetInitDone) {
        return;
      }
      this._targetInitDone = true;

      this.syncCategoryKeyFromStore();

      if (this.categoryKey == "Custom_Job_Titles") {
        this.valueAnyOf = true;
        this.tabSelected = 2;
      }

      this.calcShareTagLimit();
      this.syncPlacesFromStore();

      if (this.version === 2) {
        this.scheduleFilterValidation();
      }
    },
    changeSomething() {
      if (!this.targetReady) {
        return;
      }

      this._pendingFilterMismatchCheck = true;
      this.filterTotalMismatchVisible = false;
      this.relaunchSalesridgeMessage = "";

      if (this.poupView) {
        this.getApollo();
      } else {
        this.calculateSize();
        this.getApollo();
      }
    },
    relaunchSalesridgeSearch() {
      const targetId = Number(this.onBoarding.orderId);
      if (!targetId || this.relaunchingSalesridge) {
        return;
      }

      const confirmed = window.confirm(
        this.$t("lang.search.filter_relaunch_salesridge_confirm")
      );
      if (!confirmed) {
        return;
      }

      this.relaunchingSalesridge = true;
      this.relaunchSalesridgeMessage = "";

      targetsService
        .relaunchSalesridgeSearch(targetId)
        .then((res) => {
          this.relaunchSalesridgeMessage =
            (res && res.detail) ||
            this.$t("lang.search.filter_relaunch_salesridge_success");
          this.relaunchSalesridgeMessageClass = "text-success";
        })
        .catch((err) => {
          this.relaunchSalesridgeMessage = formatSalesridgeRelaunchError(
            this.$i18n,
            err
          );
          this.relaunchSalesridgeMessageClass = "text-danger";
        })
        .finally(() => {
          this.relaunchingSalesridge = false;
        });
    },

    getLocationsApollo() {
      targetsService.getLocationsApollo(this.searchQuery).then(res => {
        // console.log(res)
        this.locations = res.tags;
        this.locations = this.locations.filter(location => {
          if (this.selectedOptions.indexOf(location.cleaned_name) === -1) {
            return location;
          }
        });
      });
    },
    getLocations() {
      let url = `https://api.mapbox.com/geocoding/v5/mapbox.places/${this.searchQuery}.json?limit=10&proximity=-57.97274700000003%2C-34.95856661694713&language=es-419&access_token=pk.eyJ1Ijoic3ZjLW9rdGEtbWFwYm94LXN0YWZmLWFjY2VzcyIsImEiOiJjbG5sMnExa3kxNTJtMmtsODJld24yNGJlIn0.RQ4CHchAYPJQZSiUJ0O3VQ`;
      axios
        .get(url, {})
        .then(response => {
          this.locations = response.data.features;

          this.filterLocations();
        })
        .catch(error => {
          console.log(error);
        });
    },
    filterLocations() {
      this.locations = this.locations.filter(item => {
        return (
          item.id.includes("place") ||
          item.id.includes("country") ||
          item.id.includes("region")
        );
      });
    },
    addOption(option) {
      this.loadingCategory = true;
      if (option.cleaned_name) {
        let element = {
          id: option.cleaned_name,
          label: option.cleaned_name
        };

        this.placesOptions.push(element);
        this.selectedOptions.push(option.cleaned_name);
      } else {
        let element = {
          id: option,
          label: option
        };
        this.placesOptions.push(element);
        this.selectedOptions.push(option);
      }

      this.$store.state.onboarding.target.places = this.selectedOptions;

      this.searchQuery = "";
      this.filteredOptions = [];
      this.locations = [];
      setTimeout(() => {
        this.loadingCategory = false;
      }, 1);
      if (this.selectedOptions.length > 0) {
        //this.changeSomething();
      }
    },
    // Función para eliminar una opción de la lista de seleccionados
    removeOption(option) {
      this.loadingCategory = true;

      this.selectedOptions.filter(el => {
        return el != option.id;
      });

      this.placesOptions.filter(eleme => {
        return eleme.id != option.id;
      });
      //this.placesOptions.splice(index, 1);
      this.$store.state.onboarding.target.places = this.selectedOptions;
      setTimeout(() => {
        this.loadingCategory = false;
      }, 1);
      //this.changeSomething();
    }
    //     hoverOptionActive(option) {
    //   this.hoverOption = option;
    // },
  }
};
</script>
<style scoped>
.text-gray {
  color: darkgray;
}

/* Switch Toggle Styles */
.switch {
  position: relative;
  display: inline-block;
  width: 50px;
  height: 24px;
}

.switch input {
  opacity: 0;
  width: 0;
  height: 0;
}

.slider {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #ccc;
  transition: 0.4s;
  border-radius: 24px;
}

.slider:before {
  position: absolute;
  content: "";
  height: 18px;
  width: 18px;
  left: 3px;
  bottom: 3px;
  background-color: white;
  transition: 0.4s;
  border-radius: 50%;
}

input:checked + .slider {
  background-color: #5055ea;
}

input:checked + .slider:before {
  transform: translateX(26px);
}

input:disabled + .slider {
  opacity: 0.6;
  cursor: not-allowed;
}
</style>
